import React, { FC } from 'react';

import { Svg } from '@lglp/components';

import styles from './SearchIcon.module.scss';

const SearchIcon: FC<SearchIconProps> = ({ className, ...rest }) => {
  return (
    <Svg
      className={[styles.searchIcon, className]}
      viewBox="0 0 16.755 16.414"
      {...rest}
    >
      <g transform="translate(1 1)">
        <path
          d="M270.311,227.044a5.164,5.164,0,1,0-5.164,5.164A5.164,5.164,0,0,0,270.311,227.044Z"
          transform="translate(-259.983 -221.88)"
        />
        <line x1="5.358" y1="5.358" transform="translate(8.983 8.642)" />
      </g>
    </Svg>
  );
};

type SearchIconProps = {
  className?: string;
};

export default SearchIcon;
